import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { OnboardingProductsStore } from '../../../store/store';
import { Store } from '@ngrx/store';
import { UiActions } from '../../../store/actions';
import { StepsClientTypes, StepsNotClientTypes } from 'src/app/shared/enums';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { LoadingService } from 'src/app/services/loading.service';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { DataClientService } from 'src/app/services/data-client.service';

@Component({
  selector: 'lib-no-offer',
  templateUrl: './no-offer.component.html',
  styleUrls: ['../../../global.scss', './no-offer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NoOfferComponent implements OnInit {
  privateMode = false;
  dataService: DataNotClientService | DataClientService;
  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    public loadingService: LoadingService,
    private sessionService: SessionService,
    private dataClientService: DataClientService,
    private dataNotClientService: DataNotClientService
  ) {
    this.setService();
  }
  ngOnInit() {
    document.getElementById('white-container').style.display = 'block';
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
  }

  back() {
    if (this.privateMode) {
      this.loadingService.loading = true;
      if (this.sessionService.isJointAccount === '1') {
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_PRIVATE_LANDING_JOINT }));
      } else {
        this.store.dispatch(UiActions.Navigate({ step: StepsClientTypes.STEP_OFFER }));
      }
    } else {
      this.store.dispatch(UiActions.Navigate({ step: StepsNotClientTypes.STEP_PUBLIC_LANDING }));
    }
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.dataService = this.privateMode ? this.dataClientService : this.dataNotClientService;
    const googleAnalytics = {is_joint_account: this.dataService.isIsJointAccount()};
    this.store.dispatch(TagPage({text: 'without-offer', extras: googleAnalytics}));
  }
}
